
import './blocks/collection/collection.js';
import './blocks/description/description.js';
import './blocks/footer/footer.js';
import './blocks/game/game.js';
import './blocks/header/header.js';
import './blocks/results/results.js';
import './blocks/reviews/reviews.js';
import './blocks/start/start.js';
import './assets/styles/main.scss';

import './assets/audio/Home in Florence.mp3';
import './assets/img/assassins-creed-2.jpg';

import './assets/audio/The Spine.mp3';
import './assets/img/transistor.jpg';

import './assets/audio/This War of Mine.mp3';
import './assets/img/this_war_of_mine.jpg';

import './assets/audio/Vehicle 4.mp3';
import './assets/img/battlefield-1942.jpg';

import './assets/audio/Wolven Storm.mp3';
import './assets/img/witcher3.jpg';

import './assets/audio/Parkan.mp3';
import './assets/img/parkan.jpg';

import './assets/audio/Plants vs Zombies.mp3';
import './assets/img/Plants vs Zombies.jpg';

import './assets/audio/redalert2.mp3';
import './assets/img/redalert2.jpg';

import './assets/audio/Xenoblade Chronicles.mp3';
import './assets/img/Xenoblade Chronicles.jpg';

import './assets/audio/ducktales.mp3';
import './assets/img/ducktales.jpg';

import './assets/audio/Super Mario 64.mp3';
import './assets/img/Super Mario 64.jpg';

import './assets/audio/The Legend of Zelda Breath of the Wild.mp3';
import './assets/img/The Legend of Zelda Breath of the Wild.jpg';

import './assets/audio/Donkey Kong Country Tropical Freeze.mp3';
import './assets/img/Donkey Kong Country Tropical Freeze.jpg';

import './assets/audio/Splatoon.mp3';
import './assets/img/Splatoon.jpg';

import './assets/audio/Command and Conquer Generals.mp3';
import './assets/img/Command and Conquer Generals.jpg';

import './assets/audio/age of empires III.mp3';
import './assets/img/age of empires III.jpg';

import './assets/audio/dota2.mp3';
import './assets/img/dota2.jpg';

import './assets/audio/stellaris.mp3';
import './assets/img/stellaris.jpg';

import './assets/audio/bioshock.mp3';
import './assets/img/bioshock.jpg';

import './assets/audio/fallout3.mp3';
import './assets/img/fallout3.jpg';

import './assets/audio/skyrim.mp3';
import './assets/img/skyrim.jpg';

import './assets/audio/stalker.mp3';
import './assets/img/stalker.jpg';

import './assets/audio/metro.mp3';
import './assets/img/metro.jpg';

import './assets/audio/farcry5.mp3';
import './assets/img/farcry5.jpg';

import './assets/audio/walkingdead.mp3';
import './assets/img/walkingdead.jpg';

import './assets/audio/lifeisstrange.mp3';
import './assets/img/lifeisstrange.jpg';

import './assets/audio/heavyrain.mp3';
import './assets/img/heavyrain.jpg';

import './assets/audio/beyondtwosouls.mp3';
import './assets/img/beyondtwosouls.jpg';

import './assets/audio/detroitbecomehuman.mp3';
import './assets/img/detroitbecomehuman.jpg';

import './assets/audio/untildawn.mp3';
import './assets/img/untildawn.jpg';

import './assets/audio/hearthstone.mp3';
import './assets/img/hearthstone.jpg';

import './assets/audio/masseffect3.mp3';
import './assets/img/masseffect3.jpg';

import './assets/audio/eldenring.mp3';
import './assets/img/eldenring.jpg';

import './assets/audio/nfsunderground.mp3';
import './assets/img/nfsunderground.jpg';

import './assets/audio/flatout2.mp3';
import './assets/img/flatout2.jpg';

import './assets/audio/frostpunk.mp3';
import './assets/img/frostpunk.jpg';

import './assets/audio/correctAnswer.mp3';
import './assets/audio/wrongAnswer.mp3';

import './assets/img/ranks/cube.png';
import './assets/img/ranks/courier.png';
import './assets/img/ranks/settler.png';
import './assets/img/ranks/assassin.png';
import './assets/img/ranks/mrHandy.png';
import './assets/img/ranks/space-marine.png';
import './assets/img/ranks/normandy.png';

import faviconImage from './assets/icons/favicon.ico';
import { HeaderControls } from './blocks/header/header.js';
import { StartControls } from './blocks/start/start.js';
import { DescriptionControls } from './blocks/description/description.js';
import { ReviewsControls } from './blocks/reviews/reviews.js';
import { ResultsControls } from './blocks/results/results.js';
import { CollectionControls } from './blocks/collection/collection.js';
import { GameControls } from './blocks/game/game.js';

let faviconLink = document.createElement('link');
faviconLink.rel = 'icon';
document.getElementsByTagName('head')[0].appendChild(faviconLink);
faviconLink.href = faviconImage;
faviconLink.href = faviconImage;

let pageLang;
let pageTheme;

class MainControls {
  constructor() {
  }

  connectNewGameButtons() {
    let resultsButton = document.querySelector('.results-message__button-again');
    let startButton = document.querySelector('.start__button');

    if (resultsButton) {
      resultsButton.addEventListener('click', () => {
        clearPage();

        gameControl.buildGameSection(headerControl.lang, headerControl.theme);
        gameControl.buildRound();

        gameControl.createOptionsListeners();

        headerControl.volumeControl();
        headerControl.volumeSlidersActualize();
        playerControl();
      })
    }

    if (startButton) {
      startButton.addEventListener('click', () => {
        clearPage();

        gameControl.buildGameSection(headerControl.lang, headerControl.theme);
        gameControl.buildRound();

        gameControl.createOptionsListeners();

        headerControl.volumeControl();
        headerControl.volumeSlidersActualize();
        playerControl();
      })
    }
  }

  connectMainPageButtons() {
    let startButtons = Array.from(document.querySelectorAll('.main'));

    Array.from(document.querySelectorAll('.logo')).forEach((e) => {
      startButtons.push(e);
    })

    startButtons.forEach(e => {
      e.addEventListener('click', () => {
        clearPage();

        startControl.buildStartSection(headerControl.lang, headerControl.theme);

        descriptionControl.buildDescriptionSection(headerControl.lang, headerControl.theme);
        reviewsControl.buildReviewsSection(headerControl.lang, headerControl.theme);

        headerControl.volumeControl();
        headerControl.volumeSlidersActualize();

        mainControl.connectNewGameButtons();
      })
    })
  }

  connectMainPageResultSectionButton() {
    let resultsButton = document.querySelector('.results-message__button-back');

    resultsButton.addEventListener('click', () => {
      clearPage();

      startControl.buildStartSection(headerControl.lang, headerControl.theme);

      descriptionControl.buildDescriptionSection(headerControl.lang, headerControl.theme);
      reviewsControl.buildReviewsSection(headerControl.lang, headerControl.theme);

      headerControl.volumeControl();
      headerControl.volumeSlidersActualize();

      mainControl.connectNewGameButtons();
    })
  }
}

let mainControl = new MainControls();

window.addEventListener('beforeunload', () => {
  localStorage.setItem('language', headerControl.lang);
  localStorage.setItem('theme', headerControl.theme);
})

let headerControl = new HeaderControls(pageLang, pageTheme, 30);
let startControl = new StartControls(headerControl.lang, headerControl.theme);
let descriptionControl = new DescriptionControls(headerControl.lang, headerControl.theme);
let reviewsControl = new ReviewsControls(headerControl.lang, headerControl.theme);
let resultsControl = new ResultsControls(headerControl.lang, headerControl.theme);
let collectionControl = new CollectionControls();
let gameControl = new GameControls(0, 0, 0, -1);

startControl.buildStartSection(headerControl.lang, headerControl.theme);
mainControl.connectNewGameButtons();
descriptionControl.buildDescriptionSection(headerControl.lang, headerControl.theme);
reviewsControl.buildReviewsSection(headerControl.lang, headerControl.theme);

let mainSection = document.querySelector('.main-section');

let linksCollectionPage = Array.from(document.querySelectorAll('.collection'));
let linksResultsPage = Array.from(document.querySelectorAll('.results'));
let linksGamePage = Array.from(document.querySelectorAll('.game'));

mainControl.connectMainPageButtons();

linksCollectionPage.forEach(e => {
  e.addEventListener('click', () => {
    clearPage();

    collectionControl.buildCollectionSection(headerControl.lang, headerControl.theme);
    headerControl.volumeControl();
    headerControl.volumeSlidersActualize();
    playerControl();
  })
})

linksResultsPage.forEach(e => {
  e.addEventListener('click', () => {
    clearPage();

    resultsControl.buildResultsSection(headerControl.lang, headerControl.theme);
  })
})

linksGamePage.forEach(e => {
  e.addEventListener('click', () => {
    clearPage();

    gameControl.buildGameSection(headerControl.lang, headerControl.theme);
    gameControl.buildRound();

    gameControl.createOptionsListeners();

    headerControl.volumeControl();
    headerControl.volumeSlidersActualize();
    playerControl();
  })
})

headerControl.languageChanger();

headerControl.themeChanger();
headerControl.volumeControl(true);
headerControl.volumeSlidersActualize();


playerControl();

function playerControl() {
  let audioArray = Array.from(document.querySelectorAll('audio'));
  let playerButtonsArray = Array.from(document.querySelectorAll('.player__button'));
  let timelineProgress = Array.from(document.querySelectorAll('.timeline__progress'));
  let audioProgressTime = Array.from(document.querySelectorAll('.audio-progress__time'));
  let audioProgressTimeline = Array.from(document.querySelectorAll('.audio-progress__timeline'));

  playerButtonsArray.forEach((e, i) => {
    e.addEventListener('click', () => {
      if (e.classList.contains('player__button_icon_play')) {
        audioArray.forEach((e) => {
          e.pause();
        })
        let activeAudio = document.querySelector('.player__button_icon_pause');
        if (activeAudio) {
          activeAudio.classList.remove('player__button_icon_pause');
          activeAudio.classList.add('player__button_icon_play');
        }
        e.classList.add('player__button_icon_pause');
        e.classList.remove('player__button_icon_play');
        audioArray[i].play();
      } else {
        e.classList.add('player__button_icon_play');
        e.classList.remove('player__button_icon_pause');
        audioArray[i].pause();
      }
    })
  })


  setInterval(() => {
    audioArray.forEach((e, i) => {
      if (timelineProgress[i]) {
        timelineProgress[i].style.width = `${e.currentTime / e.duration * 100}%`

        if (e.duration) {
          audioProgressTime[i].textContent = `${(Math.floor(e.currentTime / 60) + '').padStart(2, '0')}:${(Math.floor(e.currentTime % 60) + '').padStart(2, '0')}/${(Math.floor(e.duration / 60) + '').padStart(2, '0')}:${(Math.floor(e.duration % 60) + '').padStart(2, '0')}`;
        } else {
          switch (audioProgressTime[i].textContent) {
            case ('.......'):
              audioProgressTime[i].textContent = 'L......';
              break;

            case ('L......'):
              audioProgressTime[i].textContent = 'LO.....';
              break;

            case ('LO.....'):
              audioProgressTime[i].textContent = 'LOA....';
              break;

            case ('LOA....'):
              audioProgressTime[i].textContent = 'LOAD...';
              break;

            case ('LOAD...'):
              audioProgressTime[i].textContent = 'LOADI..';
              break;

            case ('LOADI..'):
              audioProgressTime[i].textContent = 'LOADIN.';
              break;

            case ('LOADIN.'):
              audioProgressTime[i].textContent = 'LOADING';
              break;

            case ('LOADING'):
              audioProgressTime[i].textContent = '.......';
              break;

            default:
              audioProgressTime[i].textContent = '.......';
          }
        }

        if (e.currentTime === e.duration) {
          e.currentTime = 0;
        }
      }
    });
  }, 500);

  audioProgressTimeline.forEach((e, i) => {
    e.addEventListener('click', (event) => {
      audioArray[i].currentTime = audioArray[i].duration * ((event.clientX - e.offsetLeft) / e.clientWidth);
    })
  })
}

function clearPage() {
  mainSection.innerHTML = '';
}

export { MainControls };